import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Scrollspy from "react-scrollspy";

const DottedScrollSpy = ({ items }) => {
  return (
    <div className="dotted-scrollspy clearfix d-none d-sm-block">
      <Scrollspy
        items={["home", "about", "skills", "works", "contact"]}
        currentClassName="active"
        offset={-50}
        onUpdate={(el) => {}}
        className="nav smooth-scroll flex-column"
      >
        {items.map((item, index) => (
          <li className="nav-item" key={item + index}>
            <Tooltip title={item.title} arrow placement="left">
              <a className="nav-link" href={item.href}>
                <span></span>
              </a>
            </Tooltip>
          </li>
        ))}
      </Scrollspy>
    </div>
  );
};

export default DottedScrollSpy;
